// extracted by mini-css-extract-plugin
export var searchHeader = "_82-0";
export var searchHeaderDark = "_82-1";